export default {"src":"/_next/static/media/enterpriseType.ede9e587.svg","height":21,"width":22,"blurWidth":0,"blurHeight":0};